export default "__VITE_ASSET__9641aec6__"